export enum EventType {
    XMAS_2021 = 'xmas_2021',
    EASTER_2022 = 'easter_2022',
    JUL4_2022 = 'jul4_2022',
    HALLOWEEN_2022 = 'halloween_2022',
    XMAS_2022 = 'xmas_2022',
    VALENTINES_2023 = 'valentines_2023',
    BLACKFRIDAY_2023 = 'blackfriday_2023',
    XMAS_2023 = 'xmas_2023',
    VALENTINES_2024 = 'valentines_2024',
    EASTER_2024 = 'easter_2024',
}
